export default class ApiConstants {
  static URL = {
    BASE: process.env.REACT_APP_BASE_URL,
    IS_USER_EXIST: 'v1/iam/auth/user',
    SIGN_UP: 'v1/iam/auth/sign-up/web'
  };
}
